import {get, post} from "@/config/api";

const state = {
  FontSize: 0,
  refer: "",
  Settings: {},
  PageConfig: {},
  Line: 0,
};

const getters = {
  getFontSize(state) {
    if (state.FontSize) {
      return parseInt(state.FontSize)
    }
    let fontSize = window.$cookies.get("fontSize")
    if (fontSize) {
      return parseInt(fontSize)
    } else {
      return 20
    }
  },

  getRefer(state) {
    if (state.refer) {
      return state.refer
    }

    try {
      let s = localStorage.getItem("inwx_refer")
      if (s) {
        let obj = JSON.parse(s)
        if (obj && obj.refer && (Math.floor(Date.now() / 1000) - obj.ts < 43200)) {
          return obj.refer
        }
      }
    } catch (e) {
      console.log(e)
    }
    return ""
  },

  getPageConfig(state) {
    if (state.PageConfig && state.PageConfig.background_color) {
      return state.PageConfig
    }

    try {
      let s = localStorage.getItem("inwx_novel_config")
      if (s) {
        let obj = JSON.parse(s)
        if (obj) {
          return obj
        }
      }
    } catch (e) {
      console.log(e)
    }
    return {}
  },

  getLastReadPage(state) {
    return (itemId) => {
      try {
        let s = localStorage.getItem("novel_r_" + itemId)
        if (s) {
          return s
        }
        return ''
      } catch (e) {
        return ''
      }
    }
  },

  getLineId(state) {
    if (state.Line) {
      return parseInt(state.Line)
    }
    let line = window.$cookies.get("lineV4")
    if (line) {
      return parseInt(line)
    } else {
      return 0
    }
  },

};

const mutations = {};

const actions = {
  SetFontSize({}, fontSize) {
    state.FontSize = fontSize
    window.$cookies.set("fontSize", "" + fontSize)
  },

  SetLine({}, line) {
    state.Line = line.id
    if (!line.noSave) {
      window.$cookies.set("lineV4", "" + line.id)
    }
  },

  SetPageConfig({getters}, pageConfig) {
    let conf = getters.getPageConfig
    for (let key in pageConfig) {
      if (pageConfig.hasOwnProperty(key)) {
        conf[key] = pageConfig[key]
      }
    }

    try {
      let v = JSON.stringify(conf)
      localStorage.setItem("inwx_novel_config", v)
    } catch (e) {
      console.log(e)
    }

    state.PageConfig = conf
  },

  SetRefer({}, refer) {
    try {
      let obj = {
        "ts": Math.floor(Date.now() / 1000),
        "refer": '' + refer,
      }
      let v = JSON.stringify(obj)
      localStorage.setItem("inwx_refer", v)
    } catch (e) {
      console.log(e)
    }
    state.refer = '' + refer
  },

  SetLastReadPage({}, data) {
    try {
      localStorage.setItem("novel_r_" + data.item_id, '' + data.page)
    } catch (e) {
      console.log(e)
    }
  },

  GetMp({}, params) {
    return new Promise((resolve, reject) => {
      get(`mp/recommend/`, params).then((data) => {
        resolve(data)
      }, (err) => {
        reject(err)
      })
    })
  },

};

export default {
  state,
  getters,
  actions,
  mutations,
};
